var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.products.length)?_c('div',{staticClass:"bg-white my-4 p-3"},[_c('h5',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.$t('prodotti_suggeriti')))]),_vm._v(" "),_c('inc-product-list',{attrs:{"products":this.products}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }